import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { Header2, P1 } from '../../components/Typography';
import { REPOSIT_PUBLISHED_QUERY } from '../RepositOffer/reposit-offer';
import { useLocation } from 'react-router';
import { useQuery } from '../../hooks/useQuery';

export const RepositOfferAccepted: React.FC = () => {
  const location = useLocation();
  const query = useQuery(location);
  const repositPublished = query && query.get(REPOSIT_PUBLISHED_QUERY) === 'true';
  return (
    <Container fluid>
      <Row>
        <Col>
          <Header2 style={{ fontSize: '1.7em' }}>Thank you for choosing to proceed with Reposit on your new tenancy. </Header2>
          <P1 style={{ fontSize: '1.4em', marginTop: 24 }}>
            {repositPublished
              ? 'We will email you shortly with the next steps and inform your agent that you have chosen us.'
              : 'Your agent has been emailed with the next steps and you will receive an email with instructions on how to proceed.'}
          </P1>
        </Col>
      </Row>
    </Container>
  );
};
